const state = {
  visitedTabs: JSON.parse(localStorage.getItem('visitedTabs')) || [
    {
      path: '/home',
      title: '首页',
      fullPath: '/home',
      meta: { affix: true }
    }
  ],
  activeTab:localStorage.getItem('activeTab') || '/home'
}
const mutations = {
  ADD_TAB: (state, tab) => {
    // 排除不需要标签页的路由
    const excludePaths = ['/login', '/404']
    if (excludePaths.includes(tab.path)) {
      return
    }
    
    // 检查路由meta配置，只有明确设置tab:true或未设置的才添加
    const shouldAddTab = tab.meta?.tab !== false
    
    if (!shouldAddTab) {
      return
    }
    
    // 防止重复添加
    if (state.visitedTabs.some(v => v.path === tab.path)) return
    
    state.visitedTabs.push({
      title: tab.title,
      path: tab.path,
      fullPath: tab.fullPath,
      meta: tab.meta // 保存meta信息，方便后续使用
    })
    
    localStorage.setItem('visitedTabs', JSON.stringify(state.visitedTabs))
    localStorage.setItem('activeTab', tab.path)
  },
  REMOVE_TAB: (state, path) => {
    state.visitedTabs = state.visitedTabs.filter(tab => tab.path !== path)
    localStorage.setItem('visitedTabs', JSON.stringify(state.visitedTabs))
  },
  SET_ACTIVE_TAB: (state, path) => {
    state.activeTab = path
    localStorage.setItem('activeTab', path)
  }
}
const actions = {
  addTab({ commit }, tab) {
    commit('ADD_TAB', tab)
    commit('SET_ACTIVE_TAB', tab.path)
  },
  removeTab({ commit, state }, path) {
    return new Promise(resolve => {
      commit('REMOVE_TAB', path)
      resolve(state.visitedTabs)
    })
  },
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}